import AuthAPI from './authInstance'

const getAll = async (pageNum) => {
  const response = await AuthAPI.get(`/admin/order/list?page=${pageNum}`)
  return response.data
}

const getOrdersByType = async (type, pageNum) => {
  const response = await AuthAPI.get(`/admin/order/list/${type}?page=${pageNum}`)
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/order/show/${data}`)
  return response.data
}

const searchOrderByTrackno = async (data) => {
  const response = await AuthAPI.get(`/admin/order/${data}`)
  return response.data
}
const updateOrderStatus = async (data) => {
  const response = await AuthAPI.post(`/admin/order/update-status`, data)
  return response.data
}
export const orderService = {
  getAll,
  getOne,
  searchOrderByTrackno,
  updateOrderStatus,
  getOrdersByType,
}
